import { getFilterFormat } from "../util/dateOptions";

export interface IFilter {
  acquirerIdentification: string;
  documentNumber: string;
  documentType: number;
  processState: number;
  dianNumber: string;
  emailStateAcquirer: number;
  documentDateFrom: Date | null;
  documentDateTo: Date | null;
  receptionDateFrom: Date | null;
  receptionDateTo: Date | null;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface IDocumentTrace {
  trackId: string;
  action: string;
  actionDate: string;
  observations: IDocumentTraceObservation[];
}

export interface IDocumentTraceObservation {
  code: string;
  message: string;
}

export interface IDocumentFilterResponse {
  documentList: IDocumentList[] | null;
  length: number;
}

export interface ISendInvoiceResult {
  document: string;
  sucess: boolean;
  errorMessage: string;
}

export interface IAcquirersAutocomplete {
  identification: string;
  name: string;
}

export interface IDocumentList {
  id: string;
  documentType: string;
  erpDocumentId: string;
  docId: string;
  documentValue: number;
  documentCurrencyCode: string;
  creationDate: string;
  receptionDate: string;
  issueDate: string;
  validationDate: string;
  acquirerIdentification: string;
  acquirerName: string;
  acquirerContactEmail: string;
  processState: number;
  processStateMessage: string;
  sendAcquirerDate: string;
  emailStateAcquirer: string;
  hasGraph: string;
  hasGraphicFlag: boolean;
  cufe: string;
}

export interface IAcceptRejectDocument {
  id: string;
  documentType: string;
  erpDocumentId: string;
  docId: string;
  documentValue: number;
  documentCurrencyCode: string;
  creationDate: string;
  receptionDate: string;
  issueDate: string;
  formatedValue: string;
  validationDate: string;
  acquirerIdentification: string;
  acquirerName: string;
  acquirerContactEmail: string;
  processState: number;
  processStateMessage: string;
  sendAcquirerDate: string;
  emailStateAcquirer: string;
  hasGraph: string;
  supplierlogo: string;
  suppliername: string;
  cufe: string;
  qrData: string;
}

export interface IAcceptRejectInvoice {
  id: string;
  token: string;
}

export interface IResendMailForm {
  contact: string;
  mail: string;
  subject?: string;
  ccEmail?: string;
}

export const getFilter = (filter: IFilter, pageSize: number, page: number) => {
  return {
    pageSize: pageSize,
    page: page,
    acquirerIdentification: filter.acquirerIdentification,
    documentNumber: filter.documentNumber,
    dianNumber :filter.dianNumber,
    documentType: filter.documentType,
    processState: filter.processState,
    emailStateAcquirer: filter.emailStateAcquirer,
    documentDateFrom: getFilterFormat(filter.documentDateFrom),
    documentDateTo: getFilterFormat(filter.documentDateTo),
    receptionDateFrom: getFilterFormat(filter.receptionDateFrom),
    receptionDateTo: getFilterFormat(filter.receptionDateTo),
    sortBy: filter.sortBy,
    sortDirection: filter.sortDirection,
  };
};
